import { Component } from '@angular/core';

@Component({
  selector: 'num-placeholder-box',
  templateUrl: './placeholder-box.component.html',
  styleUrls: ['./placeholder-box.component.scss'],
})
export class PlaceholderBoxComponent {}
